import * as yup from 'yup'

export const laundryConfigDaysSchema = yup.object().shape({
  companiaId: yup.string().required('Compañía es requerida'),
  clienteId: yup.string().required('Cliente es requerido'),
  siteId: yup.string().required('Site es requerido'),
  campamentoId: yup.string().required('Campamento es requerido'),
  tipoServicio: yup.string().required('Tipo de servicio es requerido'),
  tipoHuespedId: yup.string().when('tipoServicio', {
    is: (valorCampoTipoConfiguracion) => valorCampoTipoConfiguracion === 'ROPA HUÉSPED',
    then: yup.string().required('El tipo de huésped es obligatorio'),
    otherwise: yup.string().notRequired(),
  }),
  valor: yup.number().typeError('Valor es requerido').required('Valor es requerido'),
})
